import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Company } from "src/app/core/model/Company";
import { CompanyService } from "src/app/core/services/company.service";
import { UtilityService } from "src/app/core/services/utility.service";

@Component({
  selector: "app-update-company-image",
  templateUrl: "./update-company-image.component.html",
  styleUrls: ["./update-company-image.component.scss"],
})
export class UpdateCompanyImageComponent implements OnInit {
  @ViewChild("inputImage") inputImage: ElementRef;

  @Input() company: Company;
  selectedCompany: Company;
  loading: boolean = false;

  imageFileName: string = "";
  imageUrl: any = "assets/images/placeholder.jpg";
  selectedFile: File | null = null;

  constructor(
    private companyService: CompanyService,
    private utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    this.imageUrl = this.company.logo || "assets/images/placeholder.jpg";
    this.companyService.selectedCompany.subscribe(
      (company) => (this.selectedCompany = company)
    );
  }

  openFileBrowser(event: any) {
    this.inputImage.nativeElement.click();
  }

  handleFileInput(event: any) {
    if (event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name;
      const fileTypes = ["jpg", "jpeg", "png"];
      const extension = file.name.split(".").pop().toLowerCase();

      if (fileTypes.includes(extension)) {
        this.imageFileName = fileName;
        this.selectedFile = file;

        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert("Selected file is not an image. Please select an image file.");
      }
    }
  }

  onSubmit() {
    if (!this.selectedFile) return;

    this.loading = true;
    const formData = this.companyService.createCompanyFormDate(this.company);

    formData.append("company_id", this.company.companyId);
    formData.append("image", this.selectedFile, this.selectedFile.name);

    this.companyService.updateImage(formData).subscribe((resp) => {
      this.company.logo = this.imageUrl;
      this.loading = false;

      if (this.company.companyId == this.selectedCompany.companyId) {
        this.companyService.selectedCompany.next(this.company);
      }
    });
  }

  onDelete() {
    this.loading = true;

    const formData = new FormData();
    formData.append("company_id", this.selectedCompany.companyId);

    this.companyService.deleteImage(formData).subscribe(() => {
      this.company.logo = "";
      this.imageUrl = "assets/images/placeholder.jpg";
      this.selectedFile = null;
      this.imageFileName = "";
      this.loading = false;
      window.location.reload();
    });
  }
}
